import IconArrow from '../../../../../assets/img/icon-circle-arrow-scroll.svg';
import ClickableImage from '../../../../ClickableImage/ClickableImage';
import { TradePrice } from '../../PeopleAlsoTrade.types';

import styles from './SlideButtons.module.scss';

type Props = {
  handleSlideIndex: (index: number) => void;
  slideIndex: number;
  peopleAlsoTradeData: TradePrice[];
}

const SlideButtons = (props: Props) => {
  const { slideIndex, peopleAlsoTradeData, handleSlideIndex } = props;

  return (
    <>
      {
        ((
          slideIndex === 0 && peopleAlsoTradeData.length > 5)
          || (slideIndex === 5 && peopleAlsoTradeData.length > 10)
          || (slideIndex === 10 && peopleAlsoTradeData.length > 15)
        ) && (
        <ClickableImage
          src={IconArrow}
          onClick={() => handleSlideIndex(slideIndex + 5)}
          className={styles.buttonNext}
          alt="right arrow"
        />
        )
      }
      {
        slideIndex >= 5 && (
        <ClickableImage
          src={IconArrow}
          onClick={() => handleSlideIndex(slideIndex - 5)}
          className={styles.buttonPrevious}
          alt="left arrow"
        />
        )
      }
    </>
  );
};

export default SlideButtons;
